import { Head, Link, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface VendorType {
  id: number
  name: string
  status: number
  usage_count: number
}

interface Props {
  vendor_types: VendorType[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/vendor_types" },
  { title: "Vendor Types", href: "/admin/vendor_types" },
]

export default function Index({ vendor_types }: Props) {
  const handleDelete = (id: number, usageCount: number) => {
    const message =
      usageCount > 0
        ? "This type is in use. It will be deactivated instead of deleted. Continue?"
        : "Are you sure you want to delete this type?"

    if (confirm(message)) {
      router.delete(`/admin/vendor_types/${id}`)
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Vendor Types" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Vendor Types</h1>
          <Link
            href="/admin/vendor_types/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Type
          </Link>
        </div>

        {vendor_types.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  ID
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  In Use
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {vendor_types.map((vt) => (
                <tr key={vt.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {vt.id}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {vt.name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {vt.usage_count > 0 ? vt.usage_count : ""}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/admin/vendor_types/${vt.id}/edit`}
                      className="text-hpi-active-blue mr-2 hover:underline"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(vt.id, vt.usage_count)}
                      className="text-hpi-red hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No vendor types found.</p>
        )}
      </div>
    </AppLayout>
  )
}
